import Shop from '@/shop';

const decimal = {
  // мм
  mmt: 0,
  // см
  cmt: 0,
  // дм
  dmt: 0,
  // м
  mtr: 2,
  // км
  kmt: 2,
  // дюйм
  inh: 1,
  // фут
  fot: 2,
  // ярд
  yrd: 2,
  // м2
  mtk: 2,
  // дм2
  dmk: 0,
  // мл
  mlt: 0,
  // см3
  cmq: 0,
  // л
  ltr: 2,
  // дм3
  dmq: 2,
  // м3
  mtq: 2,
  // г
  grm: 2,
  // кг
  kgm: 2,
  // т
  tne: 2,
  // час
  hur: 0,
  // боб??
  nbb: 0,
  // лист
  lef: 0,
  // набор
  set: 0,
  // пар
  npr: 0,
  // рул
  npl: 0,
  // упак
  nmp: 0,
  // дюжина упак
  dzp: 0,
  // 100 упак
  cnp: 0,
  // шт
  pce: 0,
  // 100 шт
  cen: 0,
  // тыс. шт
  mil: 0,
  // ящ
  box: 0,
  // секц
  sct: 0,
  // флак
  btl: 0,
  // пог.м
  lmt: 2
};

// Записываем в конфиг, так как нам это нужно для работы с товарами из мультикозрзины
Shop.config.config.decimal = decimal;

export default {
  options: { 'default': 'option-default' },
  showVariants: true,
  hideSelect: true,
  initOption: true,
  disableHideItem: false,
  fileUrl: {},
  filtered: true,
  allowUnavailable: false,
  selectUnavailable: true,
  imagesCombineOrder: [ 'fullFileUrl', 'images' ],

  useMax: Shop.config.get('forbid_order_over_existing').forbid_order_over_existing,
  decimal,
  withCart: false
};
